export const COMPONENT_TEXT = 'TumengText'    // 文字
const COMPONENT_NUMBER = 'TumengNumber'       // 数值
const COMPONENT_MULTI_IMG = 'TumengMultiImg'  // 图片
const COMPONENT_BLOCK = 'TumengBlock'         // 色块： 方形圆形
const COMPONENT_LINE = 'TumengLine'           // 线条
const COMPONENT_QRCODE = 'TumengQRCode'       // 二维码
const COMPONENT_BAR_CODE = 'TumengBarCode'    // 条形码
const COMPONENT_TIME = 'TumengTime'           // 时间
const COMPONENT_VALUATION = 'TumengValuation' // 评级

const COMPONENT_PRICE_TAG = 'TumengPriceTag'  // 价签
export const COMPONENT_VIDEO = 'TumengVideo'  // 视频
export const COMPONENT_AD = 'TumengAd'        // 营销位
const COMPONENT_WEB_PAGE = 'TumengWebPage'
const EDIT_APPEND = 'Edit'

export const attrText = {
  title: 'Text', // title是显示在菜单里添加组件用的
  name: 'Text', // name是显示在左边图层列表的
  type: COMPONENT_TEXT, // 组件类型,
  editType: COMPONENT_TEXT + EDIT_APPEND,
  icon: 'icon-text', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 120,
  height: 30,
  zIndex: 10,
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
  text: "Editor Text", // 组件显示的内容
  preText: '', // 前缀
  preTextDatasetField: '', // 前缀动态绑定的商品属性字段
  sufText: '', // 后缀
  sufTextDatasetField: '', // 后缀动态绑定的商品属性字段
  datasetField: '', // 动态绑定的商品属性字段
  lineBreak: '#line#', // 换行符
  spaceLineBreak: false, // 空格换行，用于非中文语言
  autoZoom: true, // 是否自动缩放 true 自动缩放  false 多余裁剪
  autoZoomMinFontSize: 0, // 自动缩放模式下最小字号，默认为0，为空或者为null时处理为0 单位px
  autoZoomLineBreak: true, // 自动缩放模式下最小字号后处理为换行还是截断 true 换行  false 多余裁剪
  fontColor: "rgba(0, 0, 0, 1)", // 字体颜色
  bgColor: "rgba(255, 255, 255, 0)", // 背景颜色
  borderColor: "rgba(0, 0, 0, 0)", // 边框颜色
  textAlign: 'center', // flex-start center flex-end
  verticalAlign: 'center', // flex-start center flex-end
  font: 'Zfull-GB',
  fontSize: 16, // 字号,
  isBold: false, // 是否加粗
  isItaly: false, // 是否倾斜
  autoTurn: false, // 是否换行
  editDirection: false, // 是否切换
  isUnderline: 'none', // 是否有下划线
  lineHeight: 1, // 单位px 默认为fontsize
  borderRadius: { // 四个角的borderadius
    leftTop: '', // 左上
    rightTop: '', // 右上
    leftBottom: '', // 左下
    rightBottom: '', // 右下
  },
  borderWidth: '', // 单位px 默认无边框
  borderRadiusLock: true, // 圆角设置时是否锁定四个角-前端用字段
  rotate: 0, // 旋转 0-360
}

export const attrNumber = {
  title: 'Number', // title是显示在菜单里添加组件用的
  name: 'Number', // name是显示在左边图层列表的
  type: COMPONENT_NUMBER, // 组件类型,
  editType: COMPONENT_NUMBER + EDIT_APPEND,
  icon: 'icon-number', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 120,
  height: 40,
  zIndex: 10,
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
  text: '9999.99', // 组件显示的内容
  datasetField: '', // 动态绑定的商品属性字段
  positiveFlag: '', // 正数符号
  negativeFlag: '', // 负数符号
  fontSpecial: 2, // 小数上漂类型： 1上标  2下标
  fontSpecialChar: '.',
  decimalPoint: '.',
  textAlign: 'center', // flex-start center flex-end
  verticalAlign: 'center', // flex-start center flex-end
  preText: '', // 前缀
  preTextDatasetField: '', // 前缀动态绑定的商品属性字段
  preTextStyle: { // 前缀样式
    isBold: false, // 是否加粗
    isItaly: false, // 是否倾斜
    isUnderline: 'none', // 是否有下划线
    alignType: '3',  // 与整数部分对齐方式 1顶部对齐  2垂直居中  3底部对齐 
    font: 'Zfull-GB', // 字体
    fontSize: 14, // 字号
  },
  thousandSeparator: '', // 千分符
  integerTextStyle: { // 整数样式
    isBold: false, // 是否加粗
    isItaly: false, // 是否倾斜
    isUnderline: 'none', // 是否有下划线
    font: 'Zfull-GB', // 字体
    fontSize: 30, // 字号
  },
  decimalPointTextStyle: {
    isBold: false, // 是否加粗
    isItaly: false, // 是否倾斜
    font: 'Zfull-GB', // 字体
    fontSize: 20, // 字号
  },
  decimalTextStyle: {
    isBold: false, // 是否加粗
    isItaly: false, // 是否倾斜
    isUnderline: 'none', // 是否有下划线
    alignType: '1',  // 对齐方式 1顶部对齐  2垂直居中  3底部对齐
    font: 'Zfull-GB', // 字体
    fontSize: 16, // 字号
  },
  sufText: '',// 后缀
  sufTextDatasetField: '', // 后缀动态绑定的商品属性字段
  sufTextStyle: { // 后缀样式
    isBold: false, // 是否加粗
    isItaly: false, // 是否倾斜
    isUnderline: 'none', // 是否有下划线
    alignType: '1',  // 对齐方式：1顶部对齐  2垂直居中  3底部对齐 4小数上方对齐 5小数下方对齐
    font: 'Zfull-GB', // 字体
    fontSize: 16, // 字号
  },
  decimalplaces: 2, // 保留小数位数
  roundingMode: 3, // 舍入模式默认四舍五入 1向上取整  2向下取整 3四舍五入 4银行家舍入
  fontColor: "rgba(0, 0, 0, 1)", // 字体颜色
  bgColor: "rgba(255, 255, 255, 0)", // 背景颜色
  // borderColor: "rgba(255, 255, 255, 0)", // 边框颜色
  // fontSpecialChar: '.', // 漂移间隔符,
  // decimalPoint:'.', // 小数点显示字段
  // fontSpecialSize: 20, // 小数漂移字号,
  fontSpecialChecked: false, // 间隔符是否漂移,
  calcType: '', // 计算类型 +加-减*乘/除%余
  calcNumber: '', // 数值+-*/% calcNumber
  exceedingDisplay: '1', // 超出显示效果 1 超出隐藏   2自动缩放
  lineHeight: 1, // 行高 0-10
  transformOrigin: 'center', // 旋转中心点
  rotate: 0, // 旋转 0-360
  clipShap: { // 四个角的borderadius
    leftTop: 0, // 左上
    leftBottom: 0, // 左下
    rightTop: 0, // 右上
    rightBottom: 0, // 右下
  },
  borderRadius: 0, // 圆角矩形 最小0最大50
}

export const attrPriceTag = {
  title: 'PriceTag', // title是显示在菜单里添加组件用的
  name: 'PriceTag', // name是显示在左边图层列表的
  type: COMPONENT_PRICE_TAG, // 组件类型,
  editType: COMPONENT_PRICE_TAG + EDIT_APPEND,
  icon: 'icon-img', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 200,
  height: 200,
  zIndex: 10,
  priceTagId: "", // 价签模板id
  priceTagName: "", // 价签模板名称
  priceTagList: [], // 图片路径
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}

export const attrMultiImg = {
  title: 'Image', // title是显示在菜单里添加组件用的
  name: 'Image', // name是显示在左边图层列表的
  type: COMPONENT_MULTI_IMG, // 组件类型,
  editType: COMPONENT_MULTI_IMG + EDIT_APPEND,
  icon: 'icon-img', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 200,
  height: 150,
  datasetField: '', // 动态绑定的商品属性字段
  zIndex: 10,
  imgList: [], // 图片路径
  picUrl: '', // 图片源
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
  borderRadius: 0, // 圆角矩形 最小0最大50
  rotate: 0, // 旋转 0-360
  isLock: true,
  clipShap: {
    leftTop: 0,
    leftBottom: 0,
    rightTop: 0,
    rightBottom: 0,
  },
}

export const attrQRCode = {
  title: 'QRCode', // title是显示在菜单里添加组件用的
  name: 'QRCode', // name是显示在左边图层列表的
  type: COMPONENT_QRCODE, // 组件类型,
  editType: COMPONENT_QRCODE + EDIT_APPEND,
  icon: 'icon-qrCode', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 100,
  height: 100,
  zIndex: 10,
  encodingType: 'QR_CODE', // 条形码编码类型 详见constant.js qrcodeList字段
  text: 'qrcode', // 默认文本
  datasetField: '',  // 动态绑定数据字段
  colorFlag: 'black', // 前端用字段 黑色black 白色white 红色red
  fontColor: 'rgba(0, 0, 0, 1)', // 二维码的颜色
  bgColor: "rgba(255, 255, 255, 0)", // 背景颜色
  contentType: '1',
  rotate: 0, // 旋转 0-360
  isDeviceCode: false, // 是否为设备码
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}

export const attrBarCode = {
  title: 'BarCode', // title是显示在菜单里添加组件用的
  name: 'BarCode', // name是显示在左边图层列表的
  type: COMPONENT_BAR_CODE, // 组件类型,
  editType: COMPONENT_BAR_CODE + EDIT_APPEND,
  icon: 'icon-barCode', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 101,
  height: 70, // 条形码容器高度   绘制背景色时  不考虑此高度  仅考虑文本和条码高度
  codeHeight: 50, // 条码高度
  zIndex: 10,
  encodingType: 'CODE_128', // 条形码编码类型 详见constant.js barcodeFormatList字段
  text: 'barcode',// 默认文本
  textPosition: 2, //  文本位置 0不显示文本  1顶部  2底部
  textStyle: { // 文本样式
    font: 'Zfull-GB', // 字体
    fontSize: 12, // 字号
    lineHeight: 20 // 文本行高
  },
  colorFlag: 'black', // 前端用字段 黑色black 白色white
  directionFlag: 0, // 绘制方向字段 黑色black 白色white
  fontColor: 'rgba(0, 0, 0, 1)', // 字体颜色(字体和条码的颜色)
  bgColor: "rgba(255, 255, 255, 0)", // 背景颜色
  datasetField: '', // 动态绑定数据字段
  rotate: 0, // 旋转 0-360
  isDeviceCode: false, // 是否为设备码
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}

export const attrVideo = {
  title: 'Video', // title是显示在菜单里添加组件用的
  name: 'Video', // name是显示在左边图层列表的
  type: COMPONENT_VIDEO, // 组件类型,
  editType: COMPONENT_VIDEO + EDIT_APPEND,
  icon: 'icon-video', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 800,
  height: 1280,
  zIndex: 10,
  videoList: [], // 视频路径
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}

export const attrAd = {
  title: 'AD', // title是显示在菜单里添加组件用的
  name: 'AD', // name是显示在左边图层列表的
  type: COMPONENT_AD, // 组件类型,
  editType: COMPONENT_AD + EDIT_APPEND,
  icon: 'icon-video', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 800,
  height: 480,
  zIndex: 10,
  videoList: [], // 视频路径
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}

export const attrWebPage = {
  title: 'Webpage', // title是显示在菜单里添加组件用的
  name: 'Webpage', // name是显示在左边图层列表的
  type: COMPONENT_WEB_PAGE, // 组件类型,
  editType: COMPONENT_WEB_PAGE + EDIT_APPEND,
  icon: 'icon-web-page', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 300,
  height: 300,
  zIndex: 10,
  borderRadius: 0, // 圆角矩形 最小0最大50
  hide: false, // 是否显示
  url: ''
}

export const attrValuation = {
  title: 'Rating',
  name: 'Rating',
  type: COMPONENT_VALUATION, // 组件类型,
  editType: COMPONENT_VALUATION + EDIT_APPEND,
  icon: 'icon-goodAppraise', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 240,
  height: 30,
  zIndex: 10,
  fontSize: 24, // 字号,
  showData: true,
  value: 5, // 评级数值，可以是4.2显示4个半星星，4.6显示5个  以此类推
  datasetField: '', // 动态绑定字段，获取的商品信息替换上面value
  preText: '', // 前缀
  preTextStyle: { // 前缀样式
    isBold: false, // 是否加粗
    isItaly: false, // 是否倾斜
    isUnderline: 'none', // 是否有下划线
    alignType: '2',  // 与整数部分对齐方式 1顶部对齐  2垂直居中  3底部对齐 
    font: 'Zfull-GB', // 字体
    fontSize: 28, // 前缀字号
  },
  // valuationType: '0', // 0:1-5分制  1：1-10分制 2：百分比制
  bgColor: 'rgba(247, 186, 42, 0)', // 背景填充色
  fontColor: 'rgba(0, 0, 0, 1)', // 前缀文本色
  iconColor: 'rgba(247, 186, 42, 1)', // 图标填充色
  exceedingDisplay: '1', // 该组件不换行 超出显示效果 1 超出隐藏   2自动缩放
  iconStyle: 'el-icon-star-on', // 评级icon样式 el-icon-star-on代表五角星（目前只有五角星）
  textAlign: 'center', // 同文本数字
  verticalAlign: 'center', // 同文本数字
  showData: false,
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}

export const attrLine = {
  title: 'Line', // title是显示在菜单里添加组件用的
  name: 'Line', // name是显示在左边图层列表的
  type: COMPONENT_LINE, // 组件类型,
  editType: COMPONENT_LINE + EDIT_APPEND,
  icon: 'icon-line', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 120,
  height: 60,
  lineWidth: 5, // 线条宽度 单位px
  zIndex: 10,
  fontColor: "rgba(0, 0, 0, 1)", // 线条颜色
  bgColor: "rgba(255, 255, 255, 0)", // 背景颜色
  lineType: 1,// 线条类型 1水平 2垂直 3左下右上 4左上右下 5 双对角线
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}


export const attrBlock = {
  title: 'Color Block', // title是显示在菜单里添加组件用的
  name: 'Color Block', // name是显示在左边图层列表的
  type: COMPONENT_BLOCK, // 组件类型,
  editType: COMPONENT_BLOCK + EDIT_APPEND,
  icon: 'icon-block', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 120,
  height: 120,
  zIndex: 10,
  bgColor: "rgba(255, 255, 255, 1)", // 背景颜色
  borderColor: "rgba(0, 0, 0, 1)", // 边框颜色
  borderRadius: {
    leftTop: '',
    rightTop: '',
    rightBottom: '',
    leftBottom: '',
  }, // 圆角数值 单位px
  borderRadiusLock: true, // 圆角锁定
  borderWidth: '', // 边框宽度
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}


export const attrTime = {
  title: 'Time', // title是显示在菜单里添加组件用的
  name: 'Time', // name是显示在左边图层列表的
  type: COMPONENT_TIME, // 组件类型,
  editType: COMPONENT_TIME + EDIT_APPEND,
  icon: 'icon-time', // 菜单和左边图层都有
  left: 0,
  top: 0,
  width: 200,
  height: 40,
  zIndex: 10,
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
  text: "", // 时间显示内容
  preText: '', // 前缀
  sufText: '', // 后缀
  datasetField: '', // 动态绑定的商品属性字段
  dateFormat: 1, // 日期格式，默认年月日1:YYYYMMDD 其他可选项月日年2:MMDDYYYY   日月年3:DDMMYYYY
  dateSeparator: '', // 日期分隔符默认为空，用户自己输入-/等等
  timeFormat: 2, // 默认显示2:24H制时间 其他可选项0:None不显示时间  1:12H小时制
  timeSeparator: ':', // 时间分隔符，默认: 用户可自行输
  autoZoom: true, // 是否自动缩放 true 自动缩放  false 多余裁剪
  fontColor: "rgba(0, 0, 0, 1)", // 字体颜色
  bgColor: "rgba(255, 255, 255, 0)", // 背景颜色
  borderColor: "rgba(0, 0, 0, 0)", // 边框颜色
  textAlign: 'flex-start', // flex-start center flex-end
  verticalAlign: 'center', // flex-start center flex-end
  font: 'Zfull-GB',
  fontSize: 32, // 字号,
  isBold: false, // 是否加粗
  isItaly: false, // 是否倾斜
  isUnderline: 'none', // 是否有下划线
  rotate: 0, // 旋转 0-360
  bgColor: "rgba(255, 255, 255, 1)", // 背景颜色
  hide: false, // 是否隐藏
  showLogic: '', // 显示逻辑字段 !结果赋值给hide字段注意是true为显示  hide字段为false  false为隐藏  hide字段为true
}